import apiClient from "./apiClient";

// ثبت‌نام کاربر جدید
export const register = async (userData) => {
 

  try {
    const { data } = await apiClient.post("/DS/admin_center/ac_user_signup.zjs", userData);

    const result = Array.isArray(data) ? data[0] : data;

    return {
      error: result.ERROR,
      message: result.ERROR_MESSAGE || result.MESSAGE,
      companyId: result.COMPANY_ID,
      partitionId: result.PARTITION_ID,
      userId: result.USER_ID,
    };
  } catch (error) {
    const errData = error.response?.data;
    throw errData || { error: "Registration failed", details: error.message };
  }
};


// ورود کاربر
export const login = async (datax) => {
  try {
    const res = await apiClient.post(`/DS/admin_center/ac_login.zjs`, datax);

    let data = res.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
    return data;
  } catch (err) {
    console.error("Select company failed:", err);
    return false;
  }
};

//  کاستمر چک وضعیت سشن
export const CustomercheckAuthStatus = async () => {
  try {
    const res = await apiClient.post(
      "/DS/admin_center/ac_check_session.zjs"
    );
    return res.data;
  } catch (err) {
    if (err.response?.status === 401) return { authenticated: false };
    throw err;
  }
};
export const logoutCustomer = async () => {
  try {
    await apiClient.post("/DS/admin_center/logout.zjs");
  } catch (err) {
    console.error("Logout failed:", err);
  }
};

// تایید ایمیل
export const resendVerificationEmail = async () => {
  try {
    const res = await apiClient.post(`/DS/admin_center/send_email_verification.zjs`);

    let data = res.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
    return data;
  } catch (err) {
    console.error("Select company failed:", err);
    return false;
  }
};
export const verifyEmailCode = async (code) => {
  try {
    const res = await apiClient.post(`/DS/admin_center/verify_email.zjs`, {
      verification_code: code
    });

    let data = res.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
    return data;
  } catch (err) {
    console.error("Select company failed:", err);
    return false;
  }
};

export const forgotPassword = async (code) => {
  try {
    const res = await apiClient.post(`/DS/admin_center/forgotPassword.zjs`, {
      verification_code: code
    });

    let data = res.data;
    if (typeof data === "string") {
      data = JSON.parse(data);
    }
    return data;
  } catch (err) {
    console.error("Select company failed:", err);
    return false;
  }
};